import React, { Component } from 'react';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import { GeoAltFill } from 'react-bootstrap-icons';
import CompoundRecipesImage from '../../images/CompoundRecipes.jpg';

class CompoundRecipes extends Component {
    render() {
        const popover = (
            <Popover className="popover-basic">
                <Popover.Title as="h3">Compound Recipes</Popover.Title>
                <Popover.Content>
                    <img src={CompoundRecipesImage} className="popover-images" alt="Compound Recipes" />
                </Popover.Content>
            </Popover>
        );

        return (
            <OverlayTrigger
                trigger="click"
                placement="auto"
                overlay={popover}
                rootClose={true}
                transition={false}
                onToggle={() => this.setState({ error: null })}
            >
                <div className="game-icons years-alpha" style={this.props.positioning}>
                    <GeoAltFill alt="Compound Recipes Clue" />
                </div>
            </OverlayTrigger>
        )
    }
}

export default CompoundRecipes